var map = {
	"./activity_bg.png": "4b13",
	"./chess_bg.png": "be5a",
	"./close_service.png": "3d0c",
	"./dialog_bg.png": "7f6d",
	"./dialog_bg02.png": "3ed2",
	"./edit-close.png": "8db9",
	"./edit-confirm.png": "f6aa",
	"./edit.png": "8817",
	"./ewm_failure.png": "46a5",
	"./icon_alipay.png": "a46e",
	"./icon_back.png": "2c8d",
	"./icon_payment_status.png": "8112",
	"./icon_payment_status_second.png": "1587",
	"./icon_person.png": "576b",
	"./icon_phone.png": "1b70",
	"./icon_service.png": "b94b",
	"./icon_service02.png": "ef27",
	"./icon_wechat.png": "259f",
	"./masker.png": "62dc",
	"./more.png": "78ec",
	"./next-step.png": "8b9e",
	"./order_bg.png": "7161",
	"./registration/bg.png": "bc2d",
	"./registration/button.png": "6653",
	"./registration/content-bg.png": "d424",
	"./registration/linebar.png": "fe1e",
	"./registration/medal.png": "68e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e767";